// ReactJS
import { useEffect, useMemo, useState } from "react";

// Material UI
import { Button, Divider, Grid, Paper, Typography } from "@mui/material";

// Context
// import { useTablon } from "../../contexts/TablonContext";
// import ViewTitulo from "../../components/Tablon/Perfil/ViewTitulo";

import { getTiempoRestante } from "../../../utils/articuloTypeUtils"


const style = {
    p: 2,
    position: "relative",
};

function Lote(pa) {

    let pventa = 0.5;
    
    return (
        <>
            <Paper
                sx={style}
                style={{
                    border: "solid 4px green",
                    // boxShadow: "0 0 3px  green",
                }}
            >
                <Grid container spacing={1}>
                    <Grid size={{ xs: 8 }}>
                        <Typography variant="h6" fontWeight={"bold"} >
                            x{pa.data.cantidad} Cristales de Mana
                        </Typography>
                        <Typography variant="body1"  >
                            Compra el: <b>{pa.data.fecha_compra}</b>
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 4 }} style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                        <Button variant="contained" className="btn-medieval">Vender</Button>
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <Typography variant="body1" >
                            Precio de Compra: <b>{pa.data.precio_compra}</b> Esmeraldas
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <Typography variant="body1" >
                            Precio de Venta: <b>{Math.floor(pa.data.precio_compra * pventa)}</b> Esmeraldas
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <Divider />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <Typography variant="body1" >
                            Caduca en: {getTiempoRestante(pa.data.fecha_caducidad)}
                        </Typography>
                    </Grid>
                </Grid>
            </Paper>
            {/* <Dialog
                open={openAction}
                onClose={handleCloseAction}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                {// eslint-disable-next-line
                    typeAction == "comprar" && <>
                        <DialogTitle id="alert-dialog-title">
                            Confirmacion de Compra
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Estas a punto de comprar un articulo.
                            </DialogContentText>
                            <DialogContentText id="alert-dialog-description">
                                Gastaras {articulo.costo} pts
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseAction}> Cancelar </Button>
                            <Button onClick={handleConfirmarCompra}>Confirmar Compra</Button>
                        </DialogActions>
                    </>}
            </Dialog> */}
        </>
    )
}

export default Lote;